module.exports = __webpack_public_path__ + "static/media/tuple.e6b50867.mjs";


//////////////////
// WEBPACK FOOTER
// ./node_modules/immutable-tuple/dist/tuple.mjs
// module id = 1260
// module chunks = 3